import { Guid } from "client_legacy/ndaw/guid";
import create, { SetState } from "zustand";

type DropOverStoreData = {
	stack: Guid[];
	add: (id: Guid) => void;
	remove: (id: Guid) => void;
};

const getInitialStore = (set: SetState<DropOverStoreData>): DropOverStoreData => ({
	stack: [],
	add: (id: Guid): void => {
		set((prevState: DropOverStoreData) => ({
			...prevState,
			stack: [...prevState.stack, id]
		}));
	},
	remove: (id: Guid): void => {
		set((prevState: DropOverStoreData) => ({
			...prevState,
			stack: prevState.stack.filter(x => x !== id)
		}));
	}
});

export const useDropOverStore = create<DropOverStoreData>(getInitialStore);
